import React, { Component } from "react"
import { connect } from "react-redux"

class reviewManagementLayout extends Component {
  render() {
    return (
      <div>
        <div className="">{this.props.children}</div>
      </div>
    )
  }
}

const mapState = () => ({})

const mapDispatch = () => {
  return {}
}

export default connect(mapState, mapDispatch)(reviewManagementLayout)
